import cartChangesToDrupal from './cartChangesToDrupal';

export default cartChangesToDrupal;
